var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Wofür wird ein Online-Termin-Kalender benötigt?")]),_c('info',[_vm._v(" Bitte gewünschten Termin-Kalender auswählen ")]),_c('calendarFormat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }